import './styles.css'
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import BCButom from '../../Tools/BCButom';
import './textSliderStyle.css'

const Slider = () => {
    return (
        <>
          <div className='indexSildBarRight'>
            <div style={{borderBottom: "#fff dashed 1px", marginBottom: "20px", paddingBottom: "10px"}}><h5>آموزشی </h5></div>
            <div className='indexSlireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>راهنمای بیماران </h5></Link></div>
            <div className='indexSlireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>آموزش به بیماران </h5></Link></div>
            <div className='indexSlireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>تالار گفت و گوی همکاران </h5></Link></div>
            <div className='indexSlireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>تالار گفت و گوی دانشجویان </h5></Link></div>
            <div className='indexSlireRightItems' style={{visibility: "hidden"}}><Link className="linksSidbar" to={`/empty`}><h5>تالار گفت و گوی دانشجویان </h5></Link></div>
            <img src='./image/Doctor/logo gold.png' className='imageLogo'  style={{marginTop: "0px"}}/>
          </div>

          <div className='indexSildBarLeft'>
            <div style={{borderBottom: "#fff dashed 1px", marginBottom: "20px", paddingBottom: "0x"}}><h5>کلینیکهای فعال </h5></div>
            <div className='indexSlireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>کلینیک واریس و لیزر</h5></Link></div>
            <div className='indexSlireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>  کلینیک زخم و پای دیابتی</h5></Link></div>
            <div className='indexSlireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>  کلینیک پایش سلامت عروقی</h5></Link></div>
            <div className='indexSlireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5> کلینیک لنف ادم(لنفوتراپی)</h5></Link></div>
            <div className='indexSlireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>   کلینیک چکاپ بیماران دیابتی</h5></Link></div>
            <img src='./image/Doctor/logo gold.png' className='imageLogo'  style={{marginTop: "10px"}}/>
          </div>
          <Carousel onTimeUpdate={`5s`} className="SliderCustomStyle" style={{}}>
            <Carousel.Item>
              <img className="d-block w-100 imageSlider"   src="./image/Slider/slide_1_OR copy.jpg" alt="First slide" />
              <Carousel.Caption className='textsSlider'>
                  {/* <div style={{maxWidth: "500px", textAlign: "center", marginRight: "30px"}}>
                      <h1 style={{color: "rgb(6, 143, 125)", textAlign: "center", marginTop: "-200px"}}><b>دکتر هادی مدقق </b></h1>
                      <h2 style={{color: "#fff", textAlign: "center"}}>فوق تخصص جراحی عروق و متخصص جراحی عمومی</h2>
                      <BCButom className='btnOne m-5' style={{background: "#199C8F !important" , color: "#fff", marginTop: "20px"}}>سوابق عملی و اجرایی</BCButom>
                  </div> */}

                  {/* <p style={{}} className='titl_2_Slid_1'>دکتر هادی مدقق </p> */}
                  <div className='TitleSlider'>
                  
                  
                  </div>
                  <div className='descriptionSlider descriptionSlider_1' style={{}}>
                  <Link to={`/about`}><BCButom className='btnOne ms-5 ' style={{marginTop: "150px", width: "220px", padding: "20px", background: "#199C8F"}}>سوابق عملی و اجرایی</BCButom></Link>
                  <a href='https://app.minns.cloud/reservations/reserve/1' target={`_blank`}> <BCButom className='btnOne ms-5 ' style={{marginTop: "150px", width: "220px", padding: "20px", background: "#009AFF"}}>نوبت دهی</BCButom></a>
                  
                  </div>
              </Carousel.Caption>
              
            </Carousel.Item>

            <Carousel.Item>
	  <img className="d-block w-100 imageSlider" src="./image/Slider/slide_2_OR.jpg" alt="Second slide" />
	  <Carousel.Caption className='textsSlider'>
		  <div className='TitleSlider TitleSlider_2'>
			<h3 style={{}}>کلینیک فوق تخصصی جراحی عروق مشهد
			<br></br>
			<br />
			<br />
			<Link to={`/empty`}><BCButom className='btnOne ms-5'>راهنمای بیماران</BCButom></Link>
			</h3>
			
		  </div>
		  <div className='descriptionSlider' style={{}}>
			{/* <div style={{textAlign: "left"}}><BCButom>asdas</BCButom></div> */}

		  </div>
		
	  </Carousel.Caption>
	</Carousel.Item>
	<Carousel.Item>
	  <img className="d-block w-100 imageSlider" src="./image/Slider/slide_3_OR.jpg" alt="Third slide" />
	  <Carousel.Caption>
		<div className='TitleSlider TitleSlider_3'>
			<h3 className='mb-3' style={{}}>

			<a href='#historySurgery'><BCButom className='btnOne ms-5 mb-5'>تاریخچه رشته جراحی عروق در مشهد</BCButom></a>
			</h3>
			
		  </div>
		  <div className='descriptionSlider' style={{}}>
			{/* <div style={{textAlign: "left"}}><BCButom>asdas</BCButom></div> */}

		  </div>
	  </Carousel.Caption>
	</Carousel.Item>
	
	<Carousel.Item >
	  <img className="d-block w-100 imageSlider" src="./image/Slider/slide_4_OR.jpg" alt="Third slide" />
	  <Carousel.Caption>

	  </Carousel.Caption>
	</Carousel.Item>
	
	<Carousel.Item>
	  <img className="d-block w-100 imageSlider" src="./image/Slider/slide_5_OR.jpg" alt="Third slide" />
	  <Carousel.Caption>
		
	  </Carousel.Caption>
</Carousel.Item>
            
          




          </Carousel>
          
        </>
      );
}

export default Slider;